import axios from "axios";
import { serverUrl } from "@/config";
import vueApp from "@/store";

export const apiClientJoin = axios.create({
  baseURL: serverUrl,
  withCredentials: false,
});

apiClientJoin.interceptors.request.use((config) => {
  // config.baseURL = `${PbxProtocol}://${vueApp.state.auth_store.userInfo.PbxServer}`;
  config.headers = {
    Authorization: "token " + vueApp.state.auth_store.userInfo.join.tokenJoin,
  };
  // console.log("Config from interceptor: ", config);
  return config;
});
